import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {User} from "../../models/user.model";
import {VetClinic} from "../../models/vet-clinic.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {TermsOfAgreement} from "../../models/terms-of-agreement.model";
import {InformationObligation} from "../../models/information-obligation.model";
import {TermsOfAgreementService} from "../../providers/terms-of-agreement.service";

@Component({
  selector: 'app-clinic-short-info',
  templateUrl: './clinic-short-info.component.html',
  styleUrls: ['./clinic-short-info.component.scss'],
})
export class ClinicShortInfoComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Input() clinic: VetClinic;
  @Input() toa: TermsOfAgreement;
  @Input() iob: InformationObligation;
  @Output() clinicDataEventEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();
  formGroup: FormGroup;
  isBusy: boolean;
  isBusySub: Subscription;
  hasUnsavedChanges: boolean;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  startDate: string;
  expiries: string;
  clinicEditSub: Subscription;


  constructor(public  commonUtils: CommonUtils,
              private appStateService: AppStateService,
              private formBuilder: FormBuilder,
              private vetClinicService: VetClinicService
  ) {
  }

  ngOnDestroy(): void {
    if(this.clinicEditSub){
      this.clinicEditSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;

    if (this.clinic.vetineoStartDate) {
      this.startDate = new Date(new Date(this.clinic.vetineoStartDate).getTime() + 7200000).toISOString();
    }
    if (this.clinic.expiries) {
      this.expiries = new Date(new Date(this.clinic.expiries).getTime() + 7200000).toISOString();
    }


  }

  changeCalendarValue($event) {
    this.startDate = $event.detail.value;
    this.hasUnsavedChanges = true;
  }

  changeExpiriesValue($event) {
    this.expiries = $event.detail.value;;
    this.hasUnsavedChanges = true;
  }

  saveChanges() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zmienić datę rozpoczęcia Vetineo dla tej lecznicy?', 'Tak', 'Nie', 'checkmark', 'close',
      () => {
        this.appStateService.updateIsBusySubject(true);
        let settings = {
          'start':this.startDate,
          'exp':this.expiries,
        }
        this.clinicEditSub = this.vetClinicService.setClinicSettings(settings, this.clinic.uuid).subscribe(e => {
          if (e) {
            this.hasUnsavedChanges = false;
            this.commonUtils.presentInfoToast('Data startu Vetineo została pomyślnie ustawiona');
          } else {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas ustawiania daty startu Vetineo');
          }

          this.appStateService.updateIsBusySubject(false);

        },error => {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas ustawiania daty startu Vetineo');
          this.appStateService.updateIsBusySubject(false);
        });
      }, () => {
      });
  }


  downloadIob(iob: InformationObligation) {
    if (iob?.url){
      this.downloadFile(iob.url);
    } else {
      this.commonUtils.presentAlertToast('Nie można pobrać aktualnego obowiązku informacyjnego, plik nie został przygotowany');
    }
  }

  downloadToa(toa: TermsOfAgreement) {
    if (toa?.url){
        this.downloadFile(toa.url);
    } else {
      this.commonUtils.presentAlertToast('Nie można pobrać aktualnego regulaminu, plik nie został przygotowany');
    }
  }

  private downloadFile(url: string) {
    window.open(url, '_blank');
  }
}
